import styled from "styled-components";

export const HeaderButtonContainer = styled.button`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
  gap: 0.75rem;
  align-items: center;
  padding: 1.5rem 0.75rem;
  border: none;
  background-color: inherit;
  cursor: pointer;
`;
